import { render, staticRenderFns } from "./GeneralInfoModel.vue?vue&type=template&id=2375c3ec&scoped=true&"
import script from "./GeneralInfoModel.vue?vue&type=script&lang=js&"
export * from "./GeneralInfoModel.vue?vue&type=script&lang=js&"
import style0 from "./GeneralInfoModel.vue?vue&type=style&index=0&id=2375c3ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2375c3ec",
  null
  
)

export default component.exports